module.exports = "/static/assets/54c9026ca39fa16e462d9753dfbe4aad.png";